<template>
    <div class="d-flex flex-row">
        <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
            data-bs-auto-close="outside" aria-expanded="false" v-text="newPermission.toTitleCase()"></button>
        <ul class="dropdown-menu dropdown-menu-end">
            <div class="list-group list-group-checkable d-grid gap-2 border-0 w-auto">
                <input class="list-group-item-check pe-none" type="radio" :name="`collaboratorMarkupAccess${collaborator?.id}`"
                    :id="`collaboratorMarkupAccess1${collaborator?.id}`" value="view" @click="update('view')" :checked="collaborator.permission === 'view'">
                <label class="list-group-item py-3" :for="`collaboratorMarkupAccess1${collaborator?.id}`">
                    View
                    <span class="d-block small opacity-50" v-text="'Allow a guest to only view the project'"></span>
                </label>

                <input class="list-group-item-check pe-none" type="radio" :name="`collaboratorMarkupAccess${collaborator?.id}`"
                    :id="`collaboratorMarkupAccess2${collaborator?.id}`" value="comment" @click="update('comment')" :checked="collaborator.permission === 'comment'">
                <label class="list-group-item py-3" :for="`collaboratorMarkupAccess2${collaborator?.id}`">
                    Comment
                    <span class="d-block small opacity-50"
                        v-text="'Allows a guest to make comments on points of the project'"></span>
                </label>

                <input class="list-group-item-check pe-none" type="radio" :name="`collaboratorMarkupAccess${collaborator?.id}`"
                    :id="`collaboratorMarkupAccess3${collaborator?.id}`" value="edit" @click="update('edit')" :checked="collaborator.permission === 'edit'">
                <label class="list-group-item py-3" :for="`collaboratorMarkupAccess3${collaborator?.id}`">
                    Edit
                    <span class="d-block small opacity-50"
                        v-text="'User will have edit rights, they will also need to create an account'"></span>
                </label>
                <div class="list-group-item">
                    <hr class="dropdown-divider">
                </div>
                <button @click="deleteCollaborator" type="button" class="list-group-item list-group-item-action list-group-item-danger" title="Delete Collaborator">
                    Remove
                </button>
            </div>
        </ul>
        <!-- <button @click="deleteCollaborator" type="button" class="btn btn-sm btn-close ms-2" title="Delete Collaborator"> -->
            <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-danger"
                width="20" height="20">
                <path fill-rule="evenodd"
                    d="M8.75 1A2.75 2.75 0 006 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 10.23 1.482l.149-.022.841 10.518A2.75 2.75 0 007.596 19h4.807a2.75 2.75 0 002.742-2.53l.841-10.52.149.023a.75.75 0 00.23-1.482A41.03 41.03 0 0014 4.193V3.75A2.75 2.75 0 0011.25 1h-2.5zM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4zM8.58 7.72a.75.75 0 00-1.5.06l.3 7.5a.75.75 0 101.5-.06l-.3-7.5zm4.34.06a.75.75 0 10-1.5-.06l-.3 7.5a.75.75 0 101.5.06l.3-7.5z"
                    clip-rule="evenodd" />
            </svg> -->
        <!-- </button> -->
    </div>
</template>

<script>
import axios from 'axios';

const controller = new AbortController

export default {
    props: ['collaborator', 'markup'],
    inject: ['notyf'],
    data() {
        return {
            newPermission: this.collaborator?.permission ? this.collaborator?.permission : 'view',
        }
    },

    methods: {
        update(value) {
            this.newPermission = value;

            axios.patch('/markup/share/collaborator/' + this.collaborator?.id, {
                permission: this.newPermission,
                markup_id: this.markup,
                invite: this.collaborator?.invite,
            }, {
                signal: controller.signal,
            })
                .then(r => {
                    const data = r.data.data;

                    this.newPermission = data.permission;

                    this.$emit('update:permission', this.newPermission)

                    this.notyf.success('Permission Updated')
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        console.log('Request canceled', error.message);
                    } else {
                        console.log(error);
                        this.notyf.error('Failed to update permission properly on server')
                    }
                })
        },
        deleteCollaborator() {
            axios.delete(`/share/markup/${this?.markup}?id=${this.collaborator?.id}&email=${this.collaborator?.email}&invite=${this.collaborator?.invite}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$emit('deleted', this.collaborator);

                        this.notyf.success("Collaborator Deleted")
                    }
                })
                .catch(error => {
                    /**
                     * @todo improve error message
                     */
                    this.notyf.error("Error deleting collaborator")
                    console.error((error))
                })
        },
    },
}
</script>
